"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6870],{

/***/ 41267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oE": function() { return /* binding */ FaceComponentContainer; },
  "in": function() { return /* binding */ FaceComponentFormik; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/Array.js + 8 modules
var es6_Array = __webpack_require__(30369);
// EXTERNAL MODULE: ./node_modules/fp-ts/es6/Option.js
var Option = __webpack_require__(36567);
// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(12258);
// EXTERNAL MODULE: ./src/components/common/Loader.tsx
var Loader = __webpack_require__(15572);
// EXTERNAL MODULE: ./node_modules/react-hook-inview/dist/esm/index.js + 2 modules
var esm = __webpack_require__(69671);
// EXTERNAL MODULE: ./src/utils/formik/commonInputToFastField.tsx
var commonInputToFastField = __webpack_require__(80263);
// EXTERNAL MODULE: ./src/utils/casePathEmptyString.ts
var casePathEmptyString = __webpack_require__(12732);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useMountedState.js
var useMountedState = __webpack_require__(84956);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(11042);
;// CONCATENATED MODULE: ./vendor/hooks/useSupportsWebP.ts




var cache = null;
function useSupportsWebP() {
    var isMounted = (0,useMountedState/* default */.Z)();
    var ref = (0,react.useState)({
        webP: cache
    }), ref1 = ref[0], supportsWebP = ref1.webP, setWebPSupport = ref[1];
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        if (cache !== null) return;
        var checkForSupport = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var browserSupportsWebP;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                __webpack_require__(76885)
                            ];
                        case 1:
                            browserSupportsWebP = _state.sent();
                            cache = browserSupportsWebP;
                            if (!isMounted()) return [
                                2
                            ];
                            setWebPSupport({
                                webP: browserSupportsWebP
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkForSupport() {
                return _ref.apply(this, arguments);
            };
        }();
        checkForSupport();
    }, [
        cache
    ]);
    return supportsWebP;
}

// EXTERNAL MODULE: ./src/utils/coerceArray.ts
var coerceArray = __webpack_require__(13762);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/common/FaceComponent/index.tsx






function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          svg switch > g > g[id$='",
        "'] {\n            & > g:not([opacity]) {\n              opacity: 1;\n            }\n            & > g[opacity] {\n              opacity: 0.6;\n            }\n            & > path {\n              fill: #ffffff;\n            }\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    ",
        ";\n  }\n\n  svg switch g > use {\n    pointer-events: none;\n  }\n\n  svg switch > g > g[tabindex] {\n    & > g {\n      pointer-events: none;\n      opacity: 0;\n      will-change: opacity, filter;\n      transition: all ",
        "s\n        ",
        ";\n    }\n\n    & > path:last-child {\n      opacity: 0;\n    }\n\n    & > path {\n      will-change: fill;\n      transition: all ",
        "s\n        ",
        ";\n      fill: #828282;\n    }\n\n    & > :last-child {\n      //opacity: 0;\n      cursor: pointer;\n    }\n  }\n\n  svg switch > g > g:hover,\n  svg switch > g > g:focus {\n    & > path:not([opacity]) {\n      fill: ",
        " !important;\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          --blur-size: 10rpx;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          --blur-size: 20rpx;\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &:before {\n        display: none;\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  position: relative;\n  padding-top: 121.2471132%;\n\n  ",
        ";\n\n  &:before {\n    filter: blur(var(--blur-size));\n    content: '';\n    ",
        ";\n    display: block;\n    background: url('",
        "');\n    background-size: contain;\n    background-repeat: no-repeat;\n\n    will-change: opacity;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}













var FaceComponentContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FaceComponent__FaceComponentContainer",
    componentId: "sc-c2cc4383-0"
})(_templateObject1(), common/* layer */.EY, function(param) {
    var theme = param.theme;
    return theme.animation.duration;
}, function(param) {
    var theme = param.theme;
    return theme.animation.easing.decelerated.toString();
}, function(param) {
    var theme = param.theme;
    return theme.animation.duration * 2;
}, function(param) {
    var theme = param.theme;
    return theme.animation.easing.decelerated.toString();
}, function(param) {
    var theme = param.theme;
    return theme.palette.neauvia;
}, function(param) {
    var $value = param.$value;
    return $value && $value.map(function(value) {
        return (0,styled_components_browser_esm.css)(_templateObject(), value);
    });
});
var FaceComponentWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FaceComponent__FaceComponentWrapper",
    componentId: "sc-c2cc4383-1"
})(_templateObject2(), common/* layer */.EY);
var FaceComponentSizer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FaceComponent__FaceComponentSizer",
    componentId: "sc-c2cc4383-2"
})(_templateObject6(), function(param) {
    var $small = param.$small;
    return $small ? (0,styled_components_browser_esm.css)(_templateObject3()) : (0,styled_components_browser_esm.css)(_templateObject4());
}, common/* layer */.EY, (__webpack_require__(81476)/* ["default"] */ .Z), (0,casePathEmptyString/* casePathEmptyString */.Q)("$fromCache")((0,styled_components_browser_esm.css)(_templateObject5())));
var LazyLoRez = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8901).then(__webpack_require__.bind(__webpack_require__, 28901));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28901)
            ];
        }
    }
});
var LazyHiRez = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9790).then(__webpack_require__.bind(__webpack_require__, 49790));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49790)
            ];
        }
    }
});
var LazyLoRezFallback = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4722).then(__webpack_require__.bind(__webpack_require__, 14722));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14722)
            ];
        }
    }
});
var LazyHiRezFallback = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2243).then(__webpack_require__.bind(__webpack_require__, 42243));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42243)
            ];
        }
    }
});
var FaceComponent = function(_param) {
    var small = _param.small, onChange = _param.onChange, value = _param.value, multi = _param.multi, props = (0,_object_without_properties/* default */.Z)(_param, [
        "small",
        "onChange",
        "value",
        "multi"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useInView */.Y)({
        threshold: 0,
        unobserveOnEnter: true
    }), 2), intersectionRef = ref[0], isVisible = ref[1];
    var supportsWebP = useSupportsWebP();
    var Component = (0,react.useMemo)(function() {
        if (supportsWebP !== null && isVisible) {
            return supportsWebP ? small ? LazyLoRez : LazyHiRez : small ? LazyLoRezFallback : LazyHiRezFallback;
        }
        return null;
    }, [
        isVisible,
        small,
        supportsWebP
    ]);
    var onClick = (0,react.useCallback)(function(e) {
        var target = e.target;
        var elementId = target.matches("g[id]") ? target.id : target.matches("g[tabindex][id] *") ? target.parentElement.id : null;
        if (elementId) {
            var id = (0,Option/* toUndefined */.FS)((0,es6_Array/* last */.Z$)(elementId.split("__")));
            if (multi) {
                var result;
                if (value == null) {
                    result = [
                        id
                    ];
                } else {
                    var coerced = (0,coerceArray/* coerceArray */.E)(value);
                    if (coerced.length === 1 && coerced[0] === id) {
                        result = undefined;
                    } else if (coerced.includes(id)) {
                        result = coerced.filter(function(v) {
                            return v !== id;
                        });
                    } else {
                        result = (0,_to_consumable_array/* default */.Z)(coerced).concat([
                            id
                        ]);
                    }
                }
                onChange === null || onChange === void 0 ? void 0 : onChange({
                    target: {
                        value: result
                    }
                });
            } else {
                var currentValue = value;
                if (currentValue === id) {
                    onChange === null || onChange === void 0 ? void 0 : onChange({
                        target: {
                            value: undefined
                        }
                    });
                } else {
                    onChange === null || onChange === void 0 ? void 0 : onChange({
                        target: {
                            value: id
                        }
                    });
                }
            }
        }
    }, [
        value,
        onChange,
        multi
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaceComponentContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: intersectionRef,
        $value: Array.isArray(value) ? value : value ? [
            value
        ] : undefined,
        onKeyDown: function(e) {
            if (e.key === " " || e.key === "Enter") {
                e.preventDefault();
                onClick(e);
            }
        },
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaceComponentSizer, {
            $small: !!small,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaceComponentWrapper, {
                children: Component ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* HeroLoaderFillLayer */.UL, {})
            })
        })
    }));
};
/* harmony default export */ var common_FaceComponent = ((/* unused pure expression or super */ null && (FaceComponent)));
var FaceComponentFormik = (0,commonInputToFastField/* commonInputToFastField */.M)(FaceComponent, {
    useTargetValue: true,
    touchOnChange: true
});


/***/ }),

/***/ 30145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ FormikAutoSubmit; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/asap/browser-asap.js
var browser_asap = __webpack_require__(69272);
var browser_asap_default = /*#__PURE__*/__webpack_require__.n(browser_asap);
;// CONCATENATED MODULE: ./src/utils/formik/createUseFSM.ts




var contains = function(a, b) {
    if (a === b) {
        return true;
    }
    for(var key in b){
        if (a[key] !== b[key]) {
            return false;
        }
    }
    return true;
};
function findTransition(transitions, prev, current) {
    var matchingTransition = transitions.find(function(t) {
        return typeof t.if === "function" ? t.if(prev, current) : contains(current, t.if);
    });
    return matchingTransition;
}
var crunchState = function(transitions, currentState, previousData, currentData) {
    var currentStateTransitions = transitions[currentState];
    var catchAllStateTransitions = transitions[""] || [];
    var currentTransitions = currentStateTransitions ? (0,_to_consumable_array/* default */.Z)(currentStateTransitions).concat((0,_to_consumable_array/* default */.Z)(catchAllStateTransitions)) : catchAllStateTransitions;
    var foundTransition = findTransition(currentTransitions, previousData, currentData);
    return foundTransition ? [
        foundTransition.then,
        foundTransition.break
    ] : [
        currentState,
        false
    ];
};
/**
 * Compute component state from data.
 * FSM starts when component mounts.
 * Can be reset when component is mounted by:
 * * supplying true to the second parameter of generated hook function.
 * * calling reset function, returned from hook as third item.
 *
 * Example: https://codesandbox.io/s/awesome-ishizaka-53pmv

 * @param transitions
 * @param initialState
 */ var createUseFSM = function(transitions, initialState) {
    var transitionsMap = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transition = _step.value;
            var prevStates = [
                ""
            ];
            if (transition.when) {
                if (typeof transition.when === "string") {
                    prevStates = [
                        transition.when
                    ];
                } else {
                    prevStates = transition.when;
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = prevStates[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var prevState = _step1.value;
                    if (!transitionsMap[prevState]) {
                        transitionsMap[prevState] = [];
                    }
                    var _$transitions = transitionsMap[prevState];
                    _$transitions.push(transition);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return function(newData, onStateChanged) {
        var _loop = function() {
            if (cnt.current === 100) {
                console.error("[createUseFSM] FSM loop detected", state.current);
                throw new Error("[createUseFSM] FSM loop detected");
            }
            var ref = (0,_sliced_to_array/* default */.Z)(crunchState(transitionsMap, state.current.state, state.current.data, newData), 2), nextState = ref[0], breakLoop = ref[1];
            state.current.data = newData;
            if (nextState === state.current.state) {
                return "break";
            }
            if (onStateChanged) {
                onStateChanged(nextState, function(updateStateFunction) {
                    browser_asap_default()(updateStateFunction);
                    breakLoop = true;
                });
            }
            cnt.current++;
            state.current.state = nextState;
            if (breakLoop) {
                return "break";
            }
        };
        var reset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var state = (0,react.useRef)({
            state: initialState,
            data: newData
        });
        var ref = (0,react.useState)(false), forceUpdate = ref[1];
        var doReset = (0,react.useCallback)(function() {
            var update = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
            state.current.data = newData;
            state.current.state = initialState;
            if (update) {
                forceUpdate(function(v) {
                    return !v;
                });
            }
        }, [
            newData,
            forceUpdate
        ]);
        if (reset) {
            doReset(false);
        }
        var cnt = (0,react.useRef)(0);
        while(true){
            var _ret = _loop();
            if (_ret === "break") break;
        }
        var justEnteredState = cnt.current > 0;
        cnt.current = 0;
        return [
            state.current.state,
            justEnteredState,
            doReset
        ];
    };
};

;// CONCATENATED MODULE: ./src/components/common/FormikAutoSubmit.tsx




var useFormikValidationFSM = createUseFSM([
    {
        when: "validating",
        if: {
            isValidating: false,
            isValid: true
        },
        then: "validated"
    },
    {
        when: "validating",
        if: {
            isValidating: false,
            isValid: false
        },
        then: "invalid"
    },
    {
        when: "newValues",
        if: {
            isValidating: true
        },
        then: "validating"
    },
    {
        when: "submitting",
        if: {
            isSubmitting: false
        },
        then: "initial"
    },
    {
        if: function(prevData, nextData) {
            return prevData.values !== nextData.values;
        },
        then: "newValues"
    },
    {
        if: function(prevData, nextData) {
            return prevData.values === nextData.initialValues;
        },
        then: "initial"
    },
    {
        if: {
            isSubmitting: true
        },
        then: "submitting"
    }, 
], "initial");
var FormikAutoSubmit = function() {
    var formik = (0,react.useContext)(formik_esm/* FormikContext */.k5);
    var ref = (0,_sliced_to_array/* default */.Z)(useFormikValidationFSM(formik), 2), state = ref[0], justEnteredState = ref[1];
    (0,react.useEffect)(function() {
        if (justEnteredState && state === "validated") {
            formik.submitForm();
        }
    }, [
        state,
        justEnteredState
    ]);
    return null;
};


/***/ }),

/***/ 89080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ MetaDescription; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function MetaDescription(props) {
    var description = props.children;
    return description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }, "twitter:description")
        ]
    }) : null;
}


/***/ }),

/***/ 78162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useFastRefreshFixer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Fixes fast refresh (or hot reload), has no effect on production.
 * Set returned value as key to the element you want to force-remount after refresh.
 */ function useFastRefreshFixer() {
    return  false ? 0 : undefined;
}


/***/ }),

/***/ 36311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ useIsRTL; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useMutationObserver.ts

var useMutationObserver = function(domNodeSelector, callback, observerOptions) {
    (0,react.useEffect)(function() {
        var targetNode = document.querySelector(domNodeSelector);
        var observer = new MutationObserver(callback);
        if (targetNode) {
            observer.observe(targetNode, observerOptions);
        }
        return function() {
            observer.disconnect();
        };
    }, [
        domNodeSelector,
        observerOptions,
        callback
    ]);
};

;// CONCATENATED MODULE: ./src/hooks/useIsRTL.ts


var checkIsRTL = function() {
    return typeof document !== "undefined" ? document.documentElement.dir === "rtl" : false;
};
var options = {
    attributes: true
};
var useIsRTL = function() {
    var ref = (0,react.useState)(checkIsRTL), isRTL = ref[0], setIsRTL = ref[1];
    var handler = (0,react.useCallback)(function(mutationList) {
        mutationList.forEach(function() {
            setIsRTL(checkIsRTL);
        });
    }, []);
    useMutationObserver("html", handler, options);
    return isRTL;
};


/***/ }),

/***/ 45499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$m": function() { return /* binding */ Showcase; }
/* harmony export */ });
/* unused harmony exports ShowcaseTitle, ShowcaseSubtitle */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68251);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_components_common_DirectusImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52520);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38108);
/* harmony import */ var src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12732);
/* harmony import */ var src_styles_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12258);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 8px;\n  }\n  ",
        " {\n    position: absolute;\n    opacity: 0;\n    transform: translateX(-15px);\n    transition: 0.15s;\n    right: -6px;\n    bottom: 10px;\n    svg {\n      height: 20px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 270px;\n  padding: 24px 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  color: ",
        ";\n  text-align: left;\n  background: ",
        ";\n  ",
        " {\n    text-align: right;\n  }\n\n  ",
        " {\n    height: 577px;\n    padding: 50px 24px;\n    &:hover {\n      ",
        " {\n        opacity: 1;\n        transform: translateX(0);\n      }\n    }\n  }\n\n  &:nth-child(2) {\n    margin-top: -30px;\n  }\n\n  &:nth-child(3) {\n    margin-top: 30px;\n  }\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(\n      0deg,\n      rgba(22, 22, 22, 0.4) 11%,\n      rgba(200, 201, 201, 0) 42%,\n      rgba(201, 201, 201, 0) 71%,\n      rgba(192, 202, 199, 0) 100%,\n      rgba(25, 27, 26, 0) 100%\n    );\n    z-index: 2;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 110%;\n\n  ",
        " {\n    font-size: 26px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  font-weight: normal;\n  font-size: 10px;\n  line-height: 110%;\n  margin-top: 10px;\n  ",
        ";\n\n  ",
        " {\n    font-size: 15px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        " {\n        padding-right: 20px;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  flex: 1;\n  max-width: 100%;\n  word-wrap: break-word;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n\n  ",
        " {\n    object-position: center center;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}










var ChevronWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "Showcase__ChevronWrapper",
    componentId: "sc-e6e44700-0"
})(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].a.withConfig({
    displayName: "Showcase__Wrapper",
    componentId: "sc-e6e44700-1"
})(_templateObject1(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.gray6;
}), function(param) {
    var theme = param.theme;
    return theme.palette.neauvia;
}, src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .dirRTL */ .gX, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, ChevronWrapper);
var ShowcaseTitle = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].h4.withConfig({
    displayName: "Showcase__ShowcaseTitle",
    componentId: "sc-e6e44700-2"
})(_templateObject2(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ShowcaseSubtitle = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "Showcase__ShowcaseSubtitle",
    componentId: "sc-e6e44700-3"
})(_templateObject3(), (0,src_styles_common__WEBPACK_IMPORTED_MODULE_9__/* .lineClamp */ .Sf)(4), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var Content = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "Showcase__Content",
    componentId: "sc-e6e44700-4"
})(_templateObject5(), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_8__/* .casePathEmptyString */ .Q)("$withChevron")((0,styled_components__WEBPACK_IMPORTED_MODULE_10__.css)(_templateObject4(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop)));
var BackgroundImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])((next_image__WEBPACK_IMPORTED_MODULE_4___default())).withConfig({
    displayName: "Showcase__BackgroundImage",
    componentId: "sc-e6e44700-5"
})(_templateObject6(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var Showcase = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_6__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var image = _param.image, title = _param.title, subtitle = _param.subtitle, withChevron = _param.withChevron, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "image",
        "title",
        "subtitle",
        "withChevron",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, props), {
        ref: ref,
        children: [
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackgroundImage, {
                as: src_components_common_DirectusImage__WEBPACK_IMPORTED_MODULE_5__/* .DirectusImage */ .q,
                src: image,
                layout: "fill"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Content, {
                $withChevron: withChevron,
                children: children || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ShowcaseTitle, {
                            children: title
                        }),
                        title && subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ShowcaseSubtitle, {
                            children: subtitle
                        }),
                        withChevron && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChevronWrapper, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_7__/* .ChevronRight */ ._, {
                                width: 24,
                                height: 14
                            })
                        })
                    ]
                })
            })
        ]
    }));
});
Showcase.displayName = "Showcase";


/***/ }),

/***/ 79429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ useBusinessCasesVideosQuery; }
});

// UNUSED EXPORTS: fetchBusinessCaseVideos

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/home/graphql/businesscases-videos.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query BusinessCaseVideosQuery(\n    $filter: videos_filter\n    $sort: [String]\n    $limit: Int\n  ) {\n    videos(filter: $filter, limit: $limit, sort: $sort) {\n      slug\n      bodyParts {\n        bodyParts_id {\n          slug\n        }\n      }\n      subjects {\n        subjects_id {\n          slug\n        }\n      }\n      speakers {\n        people_id {\n          name\n          sort\n          portrait {\n            id\n          }\n          translations {\n            title\n            degree\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var businessCaseVideosGqlQuery = (0,gql_query/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./src/modules/home/hooks/useBusinessCasesVideosQuery.ts









var fetchBusinessCaseVideos = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis, limit) {
        var directus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(businessCaseVideosGqlQuery, {
                            filter: {
                                subjects: {
                                    subjects_id: {
                                        slug: {
                                            _eq: "experts-talks"
                                        }
                                    }
                                },
                                speakers: {
                                    people_id: {
                                        portrait: {
                                            id: {
                                                _nnull: true
                                            }
                                        }
                                    }
                                }
                            },
                            limit: limit,
                            sort: [
                                "-date_created"
                            ]
                        }).then(function(d) {
                            return d.videos.filter(function(video) {
                                return video && video.speakers.length > 0;
                            }).map(function(video) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, video), {
                                    speakers: video.speakers.sort(function(a, b) {
                                        return a.people_id.sort - b.people_id.sort;
                                    })
                                });
                            });
                        })
                    ];
            }
        });
    });
    return function fetchBusinessCaseVideos(apis, limit) {
        return _ref.apply(this, arguments);
    };
}();
var useBusinessCasesVideosQuery = function(limit) {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)((0,_to_consumable_array/* default */.Z)(query/* QueryKey.BusinessCaseVideos */.S.BusinessCaseVideos).concat([
        limit
    ]), function() {
        return fetchBusinessCaseVideos(apis, limit);
    });
};


/***/ }),

/***/ 79169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ useProtocolsQuery; }
});

// UNUSED EXPORTS: protocolsQuery

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/protocols/graphql/protocol.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query {\n    protocols {\n      id\n      slug\n      logo {\n        id\n      }\n      preview {\n        id\n      }\n      previewMobile {\n        id\n      }\n      tags {\n        tags_id {\n          id\n          translations {\n            name\n            languages_code {\n              code\n            }\n          }\n          slug\n        }\n      }\n      translations {\n        name\n        languages_code {\n          name\n          code\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var protocolsGqlQuery = (0,gql_query/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./src/modules/protocols/hooks/useProtocolsQuery.ts







var protocolsQuery = function(apis) {
    return {
        queryKey: (0,_to_consumable_array/* default */.Z)(query/* QueryKey.Protocols */.S.Protocols),
        queryFn: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var directus;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apis.directus()
                        ];
                    case 1:
                        directus = _state.sent();
                        return [
                            2,
                            directus.query(protocolsGqlQuery).then(function(d) {
                                return d.protocols.sort(function(a, b) {
                                    var order = [
                                        "nboost",
                                        "nlift",
                                        "nrose"
                                    ];
                                    var aIndex = order.indexOf(a.slug);
                                    var bIndex = order.indexOf(b.slug);
                                    return aIndex - bIndex;
                                });
                            })
                        ];
                }
            });
        })
    };
};
var useProtocolsQuery = function() {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)(protocolsQuery(apis));
};


/***/ }),

/***/ 3273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ videosBasicFragment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment videosBasic on videos {\n    id\n    slug\n    date_created\n    thumbnail {\n      id\n    }\n    bodyParts {\n      bodyParts_id {\n        slug\n      }\n    }\n    subjects {\n      subjects_id {\n        slug\n      }\n    }\n    tags {\n      tags_id {\n        id\n        translations {\n          name\n          languages_code {\n            code\n          }\n        }\n      }\n    }\n    disclaimer\n    source {\n      id\n      url\n      format\n      duration\n      startDate\n      endDate\n    }\n    translations {\n      description\n      excerpt\n      name\n      languages_code {\n        code\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var videosBasicFragment = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 13762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ coerceArray; }
/* harmony export */ });
var coerceArray = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};


/***/ }),

/***/ 81476:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ("data:image/png;base64,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");

/***/ })

}]);